import { render, staticRenderFns } from "./ProductQuestions.vue?vue&type=template&id=5df41f5f&scoped=true"
import script from "./ProductQuestions.vue?vue&type=script&lang=js"
export * from "./ProductQuestions.vue?vue&type=script&lang=js"
import style0 from "./ProductQuestions.vue?vue&type=style&index=0&id=5df41f5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df41f5f",
  null
  
)

export default component.exports